import './index.scss';
import { useTranslation } from 'react-i18next';
import ChangeGymCard from '../ChangeGymCard';
import { useGymRooms } from '../../../../store/gym-management/GymHooks';

const ChangeGymRoomItems = () => {
  const { t } = useTranslation();
  const gymRooms = useGymRooms();

  return (
    <div className="change-gym-room-items">
      {gymRooms.map((room) => (
        <ChangeGymCard room={room} />
      ))}
    </div>
  );
};

export default ChangeGymRoomItems;
